export const AVATAR_PALETTE = [
  '#1e293b', '#0f172a', '#7c3aed', '#db2777', '#dc2626', '#ea580c',
  '#ca8a04', '#16a34a', '#0d9488', '#0284c7', '#2563eb', '#4338ca',
  '#9333ea', '#be123c', '#b45309', '#15803d', '#0891b2', '#1d4ed8',
]

export function hashIndex(s: string, mod: number): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return h % mod
}

export function getInitials(name: string): string {
  return String(name || '').trim().split(/\s+/).map(w => w[0] || '').slice(0, 2).join('').toUpperCase() || '·'
}

export function getAvatarColor(seed: string, palette: string[] = AVATAR_PALETTE): string {
  return palette[hashIndex(seed, palette.length)]
}
